import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import Badge from '@/shared/components/Badge';
import { Col, Spinner } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorRedHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorRedHover};

    svg {
      fill: ${colorRedHover};
    }
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const StatusFormatter = value => (
  value ? <Badge bg="success">Enable</Badge> : <Badge bg="secondary">Disable</Badge>
);

StatusFormatter.propTypes = {
  value: PropTypes.bool.isRequired,
};

const SubscriptionPriceList = (props) => {
  const [showLoader, setShowLoader] = useState(true);
  const [subscriptionPricesList, setSubscriptionPricesList] = useState({ tableHeaderData: [], tableRowsData: [] });
  const tableConfig = {
    isSortable: true,
    withPagination: false,
    withSearchEngine: false,
  };

  const handleEdit = (subscriptionPrice) => {
    props.setEditSubscriptionPrice(subscriptionPrice)
  }

  const GetSubscriptionPrices = () => {
    setShowLoader(true);
    AdminInterface.instance.getSubscriptionPrices().then((response) => {
      const columns = [
        {
          accessor: 'plan_id',
          Header: 'Id',
          disableSortBy: true
        },
        {
          accessor: 'product_name',
          Header: 'Subscription Plan'
        },
        {
          accessor: 'interval',
          Header: 'Interval'
        },
        {
          accessor: 'price',
          Header: 'Price',
          disableGlobalFilter: true
        },
        {
          accessor: 'currency',
          Header: 'Currency',
          disableGlobalFilter: true,
          disableSortBy: true
        },
        {
          accessor: 'active',
          Header: 'Is Active?',
          disableGlobalFilter: true,
          disableSortBy: true
        },
        {
          accessor: 'edit',
          Header: 'Edit',
          disableGlobalFilter: true,
          disableSortBy: true
        }
      ];
      const data = [];
      response.data.forEach(subscriptionPrice => {
        data.push({
          plan_id: subscriptionPrice.plan_id,
          product_name: subscriptionPrice.product_name,
          interval: subscriptionPrice.interval,
          price: subscriptionPrice.price,
          currency: subscriptionPrice.currency,
          active: StatusFormatter(subscriptionPrice.active),
          edit: <CartTableButton type="button" onClick={() => handleEdit(subscriptionPrice)}><EditIcon /></CartTableButton>
        });
      });

      const subscriptionPriceListTableData = { tableHeaderData: columns, tableRowsData: data };
      setSubscriptionPricesList(subscriptionPriceListTableData);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    }).finally(() => {
      setShowLoader(false);
      props.setListRequiresReload(false);
    })
  };

  useEffect(() => {
    GetSubscriptionPrices();
  }, [props.listRequiresReload]);

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>Subscription Price List</CardTitle>
          </CardTitleWrap>
          {
            !showLoader &&
            <ReactTableBase columns={subscriptionPricesList.tableHeaderData} data={subscriptionPricesList.tableRowsData} tableConfig={tableConfig} />
          }
          {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
        </CardBody>
      </Card>
    </Col>
  );
};

export default SubscriptionPriceList;